import { Component, Input } from '@angular/core';

@Component({
  selector: 'sem-info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss'],
})
export class InfoBoxComponent {
  @Input() type!: string;

  @Input() customClass!: string;

  constructor() {
    this.type = this.type ? this.type : 'primary';
    this.customClass = this.customClass ? this.customClass : '';
  }
}
